import React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {DataTypeConstraintDto} from "../../../../../common/apis/datatype/DataTypeConstraintDto";
import ExtGridWrapper from "../../../../../components/grid/ExtGridWrapper";
import {t} from "../../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "../DataTypeTranslationKey";
import {CommonTranslation} from "../../CommonTranslation";
import {PersistentStateId} from "../../../../../store/common/Grid";
import {ActionButtonType, EnabledPolicy, GridAction} from "../../../../../components/grid/GridAction";
import {Add, Delete} from "@mui/icons-material";
import {ConstraintTypeFormatter} from "./ConstraintTypeFormatter";
import {GridValueGetterParams} from "@mui/x-data-grid/models/params/gridCellParams"
import {ConstraintDataPluginRegistry} from "./ConstraintDataPluginRegistry";

interface DataTypeConstraintsGridProps {
    constraints: DataTypeConstraintDto[];

    createEnabled: boolean;
    onCreateClicked: () => void;
    onDeleteClicked: (constraintId: string) => void;
}

export default function DataTypeConstraintsGrid({constraints, createEnabled, onCreateClicked, onDeleteClicked}: Readonly<DataTypeConstraintsGridProps>) {

    const columnDefinitions: GridColDef<DataTypeConstraintDto>[] = [
        { field: 'name', headerName: t(DataTypeTranslationKey.NAME), flex: 2 },
        { field: 'type', headerName: t(DataTypeTranslationKey.CONSTRAINT_TYPE), flex: 1, valueGetter: (params) => params.row.constraintData.type, valueFormatter: (params) => ConstraintTypeFormatter.formatConstraintType(params.value, t) },
        { field: 'description', headerName: t(CommonTranslation.DESCRIPTION), flex: 2 },
        {
            field: 'expression',
            headerName: t(DataTypeTranslationKey.CONSTRAINT_EXPRESSION),
            flex: 3,
            valueGetter: (params: GridValueGetterParams) => {
                const constraint = params.row as DataTypeConstraintDto;
                const plugin = ConstraintDataPluginRegistry.getPlugin(params.row.constraintData.type);
                return plugin?.getConstraintExpression(constraint.constraintData, t) ?? '';
            }
        }

    ];

    return (
        <ExtGridWrapper
                columns={columnDefinitions}
                rows={constraints}
                rowCount={constraints.length}
                getRowId={row => row.id}
                actions={[
                    GridAction.buttonBuilder('CREATE_CONSTRAINT', ActionButtonType.IMMEDIATE, t(CommonTranslation.CREATE),
                            <Add/>)
                        .enabledPolicy(EnabledPolicy.ALWAYS)
                        .isEnabled(() => createEnabled)
                        .onClick(() => onCreateClicked())
                        .build(),
                    GridAction.buttonBuilder('DELETE_DATA_TYPE', ActionButtonType.IMMEDIATE, t(CommonTranslation.REMOVE),
                            <Delete/>)
                        .enabledPolicy(EnabledPolicy.WHEN_EXACTLY_ONE_SELECTED)
                        .isEnabled((selectedRows) => selectedRows.length === 1 && selectedRows[0].acl?.canDelete)
                        .onClick(selectedRowIds => onDeleteClicked(selectedRowIds[0]))
                        .build(),
                ]}
                resourceId=""
                peristentStateId={PersistentStateId.DATA_TYPE_CONSTRAINT_GRID}
        />
    );
}
